import { render, staticRenderFns } from "./HigherOrderAlertClassification.vue?vue&type=template&id=f36bac06"
import script from "./HigherOrderAlertClassification.vue?vue&type=script&lang=js"
export * from "./HigherOrderAlertClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports